import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { EmptyState, type EmptyVariant } from '@/shared/ui/EmptyState'
import type { LocalListState } from '@/shared/lib/localList'

interface ReportTableEmptyProps {
  filter: Pick<LocalListState, 'narrowed' | 'reset'>
  /** «Ma'lumot yo'q» holatining sarlavhasi */
  title: string
  description?: string
  variant?: EmptyVariant
  /** Eski chaqiruvchilardagi ikonka — yangi kodda `variant` afzal */
  icon?: ReactNode
}

/**
 * Jadvalning bo'sh holati — IKKI XIL VAZIYAT, IKKI XIL MATN.
 *
 * ⚠️ «Hisobotda ma'lumot yo'q» va «filtr hech narsa topmadi» ni bir xil
 * ko'rsatish eng qimmat chalkashlik: birinchisida operator davrni
 * o'zgartirishi kerak, ikkinchisida esa faqat qidiruv matnini. Bir xil
 * matn uni noto'g'ri tomonga yuborardi — va u hisobotni «bo'sh» deb
 * yopib qo'yardi.
 */
export function ReportTableEmpty({
  filter,
  title,
  description,
  variant = 'no-data',
  icon,
}: ReportTableEmptyProps) {
  const { t } = useTranslation()

  if (filter.narrowed) {
    return (
      <EmptyState
        variant="no-data"
        title={t('finance.reportTable.noMatch')}
        description={t('finance.reportTable.noMatchHint')}
        actionLabel={t('dataTable.resetFilters')}
        onAction={filter.reset}
      />
    )
  }

  return (
    <EmptyState
      variant={variant}
      title={title}
      {...(description === undefined ? {} : { description })}
      {...(icon === undefined ? {} : { icon })}
    />
  )
}
